import React from "react";
import DateInput from "../inputs/DateInput";

const DateField = ({
	register,
	error,
	placeholder = "dd/mm/yyyy",
	required = false,
	className = "",
	id,
	field,
	watch,
}) => {
	const today = new Date();
	const yyyy = today.getFullYear();
	const mm = String(today.getMonth() + 1).padStart(2, "0");
	const dd = String(today.getDate()).padStart(2, "0");
	const maxDate = `${yyyy}-${mm}-${dd}`;
	const minDate = `${yyyy - 110}-${mm}-${dd}`;

	// Function to convert DD/MM/YYYY to YYYY-MM-DD format
	const convertDateFormat = (dateString) => {
		if (!dateString) return "";

		// Check if it's already in YYYY-MM-DD format
		if (/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
			return dateString;
		}

		// Convert from DD/MM/YYYY to YYYY-MM-DD
		const parts = dateString.split("/");
		if (parts.length === 3) {
			const [day, month, year] = parts;
			return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
		}

		return dateString;
	};

	// Get the current value from the form
	const currentValue = watch ? watch(id) : "";
	const convertedValue = convertDateFormat(currentValue);

	// Get the registration object from react-hook-form
	const registration = register(id, {
		required: required ? `${field.title || "This field"} is required` : false,
		validate: (value) => {
			if (!value) return true;
			const dateValue = new Date(value);
			const min = new Date(minDate);
			const max = new Date(maxDate);
			if (dateValue < min) {
				return `Date cannot be more than 110 years ago.`;
			}
			if (dateValue > max) {
				return `Date cannot be in the future.`;
			}
			return true;
		},
	});

	return (
		<DateInput
			label=""
			placeholder={placeholder}
			required={required}
			error={error}
			hideLabel={true}
			min={minDate}
			max={maxDate}
			value={convertedValue}
			{...registration}
			name={id}
		/>
	);
};

export default DateField;
